import { render, staticRenderFns } from "./BadgeCircle.vue?vue&type=template&id=d2059398&scoped=true"
import script from "./BadgeCircle.vue?vue&type=script&lang=js"
export * from "./BadgeCircle.vue?vue&type=script&lang=js"
import style0 from "./BadgeCircle.vue?vue&type=style&index=0&id=d2059398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2059398",
  null
  
)

export default component.exports